import { createBrowserHistory } from "history";
import { BASENAME } from "consts";

const history = createBrowserHistory({
  basename: BASENAME,
});
export default history;
